import React from 'react';
import './CryptoSelector.css';

const CryptoSelector = ({ onSelectCrypto }) => {
  const cryptos = [
    { id: 'bep20', name: 'BEP20 USDT', symbol: 'BEP20', icon: '/Binancebep20.webp', color: '#f3ba2f', outOfStock: false },
    { id: 'trc20', name: 'TRC20 USDT', symbol: 'TRC20', icon: '/USDTtron.png', color: '#1dd1a1', outOfStock: false },
    { id: 'solana', name: 'SOL USDT', symbol: 'SOLANA', icon: '/Solana_logo.png', color: '#14F195', outOfStock: false },
    { id: 'bitcoin', name: 'Bitcoin', symbol: 'BTC', icon: '/Bitcoin-Logo.png', color: '#F7931A', outOfStock: false }
  ];

  return (
    <section className="crypto-selector">
      <div className="container">
        <h2>Choose Your <span className="highlight">USDT</span></h2>
        <p className="subtitle">Select your preferred blockchain network</p>
        
        <div className="crypto-grid">
          {cryptos.map((crypto) => (
            <div 
              key={crypto.id} 
              className={`crypto-card ${crypto.outOfStock ? 'out-of-stock' : ''}`}
              onClick={() => onSelectCrypto(crypto)}
            >
              {crypto.outOfStock && (
                <div className="stock-badge">
                  <span className="badge-dot"></span>
                  Out of Stock
                </div>
              )}
              <div className="crypto-icon">
                <img src={crypto.icon} alt={crypto.name} />
              </div>
              <h3>{crypto.name}</h3>
              <button className="select-btn" style={{ background: crypto.color }}>
                {crypto.symbol}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CryptoSelector;
